// © Microsoft Corporation. All rights reserved.

import { AppError } from "@msnews/core-contracts";

/**
 * Helper to create an error for logging with message and customMessage properties without having
 * to go manually clone the error object, or property bag, etc.
 * @param baseError - The base error object to use as prototype for creating the error
 * @param message - The custom message to use for the error
 * @param customMessage - The custom message that may contain strings that do not aggregate well (i.e., unique / per request data)
 */
export function createError(baseError: AppError, message: string, customMessage?: string): AppError {
    return {
        ...baseError,
        message: message || baseError.message,
        pb: customMessage
            ? { ...baseError.pb, customMessage }
            : baseError.pb
    };
}
